import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { LiveDisplayService } from '@api/live-display.service';

@Component({
  selector: 'app-live-display-kiosk-setup',
  templateUrl: './live-display-kiosk-setup.component.html',
  styleUrls: ['./live-display-kiosk-setup.component.scss']
})
export class LiveDisplayKioskSetupComponent implements OnInit {
  deviceKey: string = '';
  hideKey: boolean = true;
  isLoading: boolean = false;
  errorMessage: string | null = null;
  storedKeyExists: boolean = false;

  constructor(
    private liveDisplayService: LiveDisplayService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const existingKey = localStorage.getItem('kiosk_device_key');
    if (existingKey) {
      this.storedKeyExists = true;
    }
  }

  onConnect(): void {
    const keyToTest = this.deviceKey ? this.deviceKey.trim() : (this.storedKeyExists ? (localStorage.getItem('kiosk_device_key') || '') : '');
    if (!keyToTest) {
      this.errorMessage = 'Please enter a valid Device Key.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;
    this.cdr.markForCheck();

    this.liveDisplayService.exchangeKioskToken$(keyToTest).subscribe({
      next: (response) => {
        // Securely store the device key in localStorage
        localStorage.setItem('kiosk_device_key', keyToTest);
        // Store session token in sessionStorage (not in localStorage['jwt'])
        sessionStorage.setItem('kiosk_jwt', response.token);
        this.isLoading = false;
        this.router.navigate(['/live-display/kiosk']);
      },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 401 || err.status === 400) {
          this.errorMessage = 'Invalid Device Key. Please verify the key configured for this kiosk.';
        } else if (err.status === 429) {
          this.errorMessage = 'Too many failed attempts. Please wait a few minutes before trying again.';
        } else {
          this.errorMessage = 'Connection error. Unable to connect to Carbon server. Please check network connection.';
        }
        this.cdr.markForCheck();
      }
    });
  }

  onProceedWithStoredKey(): void {
    const existingKey = localStorage.getItem('kiosk_device_key');
    if (existingKey) {
      this.deviceKey = existingKey;
      this.onConnect();
    }
  }

  onClearStoredKey(): void {
    localStorage.removeItem('kiosk_device_key');
    sessionStorage.removeItem('kiosk_jwt');
    this.storedKeyExists = false;
    this.deviceKey = '';
    this.errorMessage = null;
    this.cdr.markForCheck();
  }
}
